import { createRouter, createWebHistory } from 'vue-router';
import Home from "../components/pages/home.vue";
import AboutPage from "../components/About.vue";
import Login from "../components/auth/login.vue";
import Register from "../components/auth/register.vue";
import Profession from "../components/pages/Profession/profession.vue";
import ProfessionsDetailsPage from "../components/pages/Profession/professionsDetailsPage.vue";
import Independents from "../components/pages/Independent/independent.vue";
import IndependentsProfilePage from "../components/pages/Independent/independentsProfilePage.vue";
import UpgradeToFreelancer from "../components/pages/Independent/UpgradeToFreelancer.vue";
import RequestService from "../components/pages/Independent/RequestService.vue";
import Profile from "../components/pages/Profile/profile.vue";
import Order from "../components/pages/Profile/order.vue";
import myPosts from "../components/pages/Profile/myPosts.vue";
import sharePost from "../components/pages/Posts/share-posts.vue";
import PostDetailsPage from "../components/pages/Posts/PostDetailsPage.vue";
import PostCommetDetailsPage from "../components/pages/Posts/PostCommetDetailsPage.vue";
import Chats from "../components/pages/chats/chats-all.vue";
import ChatPage from "../components/pages/chats/ChatPage.vue";
import SearchPage from "../components/pages/Search/search.vue";
import NotificationsPage from "../components/pages/Notifivations/notification.vue";
import CompleteProfile from "../components/pages/Profile/completeProfile.vue";
import MyWorks from "../components/pages/MyWorks/myWorks.vue";
import AddWork from "../components/pages/MyWorks/addWork.vue";
import PrivacyPolicy from "../components/pages/PrivacyPolicy/privacyPolicy.vue";
import HowWe from "../components/pages/HowWe/howWe.vue";
import MySaves from "../components/pages/Saves/saves.vue";
import PricesPage from "../components/pages/PricesPage/PricesPage.vue";

// تعريف الراوتر
const routes = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/professions',
    name: 'professionsPage',
    component: Profession,
    meta: { requiresAuth: true },
  },
  {
    path: '/professions/:id',
    name: 'professionsDetailsPage',
    component: ProfessionsDetailsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/independents',
    name: 'independentsPage',
    component: Independents,
    meta: { requiresAuth: true },
  },
  {
    path: '/upgrade-to-freelancer',
    name: 'UpgradeToFreelancer',
    component: UpgradeToFreelancer,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/independents/:id',
    name: 'independentsProfilePage',
    component: IndependentsProfilePage,
    meta: { requiresAuth: true },
  },
  {
    path: '/request-service',
    name: 'RequestService',
    component: RequestService,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: '/order/:id',
    name: 'order',
    component: Order,
    meta: { requiresAuth: true },
  },
  {
    path: '/post/:id',
    name: 'PostDetails',
    component: PostDetailsPage,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/post/commets/:id',
    name: 'PostCommetDetailsPage',
    component: PostCommetDetailsPage,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/profile-myPosts',
    name: 'myPosts',
    component: myPosts,
    meta: { requiresAuth: true },
  },
  {
    path: '/share-post',
    name: 'sharePost',
    component: sharePost,
    meta: { requiresAuth: true },
  },
  {
    path: '/chats',
    name: 'chats',
    component: Chats,
    meta: { requiresAuth: true },
  },
  {
    path: '/chat/:id',
    name: 'ChatPage',
    component: ChatPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/search',
    name: 'SearchPage',
    component: SearchPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/notifications',
    name: 'NotificationsPage',
    component: NotificationsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/complete-profile',
    name: 'CompleteProfile',
    component: CompleteProfile,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/my-works',
    name: 'MyWorks',
    component: MyWorks,
    meta: { requiresAuth: true },
  },
  {
    path: '/add-work',
    name: 'AddWork',
    component: AddWork,
    meta: { requiresAuth: true },
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: { requiresAuth: true },
  },
  {
    path: '/how-we',
    name: 'HowWe',
    component: HowWe,
    meta: { requiresAuth: true },
  },
  {
    path: '/my-saves',
    name: 'MySaves',
    component: MySaves,
    meta: { requiresAuth: true },
  },
  {
    path: '/prices-page/:id',
    name: 'PricesPage',
    component: PricesPage,
    meta: { requiresAuth: true },
  },
];

// إنشاء الراوتر
const router = createRouter({
  history: createWebHistory(),  // استخدام createWebHistory بدلاً من hash
  routes,
});

// حارس التوجيه
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated");

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next("/login");
  } else {
    next();
  }
});

export default router;
